var $6157c9954e0b6191$exports = {};
$6157c9954e0b6191$exports = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Delete za uklanjanje oznake.`
};


export {$6157c9954e0b6191$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
